/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


//  $(".product-single__swatch__label").click(function(){
//     debugger;
//         if ($(this).text() == 'Customize') {
//           $('.customize-box').show();
//           document.getElementById("customized_text").required = true;
          
          
//           $('#preloading img').each(function(){ 
// 		// Check if the ALT text matches the label
// 		if ($(this).attr("alt") == "Customize") { 
// 			// Replace the Featured image 'src' with the new image URL
// 			$('#mainImage').attr("src", $(this).attr("src")); 
// 		} 
// 	}); 
//         } else { 
//           $('.customize-box').hide(); 
// 		$('#customized_text').removeAttr('required')


//         }
       
// });

 $(document).ready(function() {
       // alert("window load occurred!");
 $('input[name=customize-b]:checked + label').trigger("click");
//   $('input[name=customize-b]').bind('click', function(){ 
// 		debugger;
// 	// Get the label of the radio button that was just clicked (this is the variant title)
// 	var label = $('input[name=id]:checked + label').text(); 

// 	// Check each image in the ImageContainer div
// 	$('#ImageContainer .thumb img').each(function(){ 
// 		// Check if the ALT text matches the label
// 		if ($(this).attr("alt") == label) { 
// 			// Replace the Featured image 'src' with the new image URL
// 			$('#Featured img').attr("src", $(this).attr("src")); 
// 		} 
// 	}); 

// });
 });